import React from "react";

import { ReactComponent as Search } from "../../../Assets/Images/Icon/SearchICON.svg";
import { TextInput7 } from "./TextInput";

const SearchInput = ({
  placeholder,
  getSearchText,
  icon,
  width,
  color,
  searchValue,
}) => {
  return (
    <TextInput7
      searchValue={searchValue}
      startAdornment
      width={width || null}
      placeholder={placeholder}
      icon={icon || <Search />}
      color={color || "#FFF"}
      getSearchText={getSearchText}
    />
  );
};

export default SearchInput;
